import React from "react";
import { apiGet, apiGetList } from "./adminApi";

/** Loaders + presentation helpers shared by the qualification screens. */

export const loadProducts = () => apiGet("hec/products/all");

export const loadStudyAreas = () => apiGetList("hec/studyArea/getStudyAreas");

export const loadInstitutionNames = async () => {
  const list = await apiGet("hec/hli/getAllHli");
  return list.map((i) => ({ value: i.fullName, label: i.institutionCode ? `${i.fullName} (${i.institutionCode})` : i.fullName }));
};

export function AreaBadge({ area }) {
  if (!area) return <span className="text-gray-400">—</span>;
  const stem = area === "STEM";
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold border ${
        stem ? "bg-indigo-50 text-indigo-700 border-indigo-200" : "bg-slate-100 text-slate-600 border-slate-200"
      }`}
    >
      {stem ? "STEM" : "NON STEM"}
    </span>
  );
}

export function ProductPill({ product }) {
  if (!product) {
    return (
      <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-500 border border-gray-200">
        Unassigned
      </span>
    );
  }
  return (
    <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-cyan-50 text-cyan-800 border border-cyan-200">
      {product.productName}
    </span>
  );
}

/** Table cell content for a qualification row. */
export function QualificationCell({ q }) {
  return (
    <div className="min-w-0">
      <div className="font-semibold text-gray-900 truncate">{q.qualificationName}</div>
      <div className="text-xs text-gray-400 font-mono">{q.qualifactionCode}</div>
    </div>
  );
}

export const paginationTheme = {
  pages: {
    selector: { active: "bg-cyan-600 text-white border-cyan-600 hover:bg-cyan-700" },
  },
};
